import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { FEATURE_FLAGS } from '@/config/constants';
import { useHasFeatureFlag } from '@/hooks/useHasFeatureFlag';
import { paths } from '@/routing/routing';

/** Gates plot-onboarding routes to staff or orgs with the plots_onboarding_client_draft flag. */
export const PlotsOnboardingProtection: FC = () => {
  const hasAccess = useHasFeatureFlag(FEATURE_FLAGS.PLOTS_ONBOARDING_CLIENT_DRAFT);

  if (!hasAccess) {
    return <Navigate to={paths.landSteward.home} replace />;
  }
  return <Outlet />;
};
